import { AuxiliumComponent } from "../auxilium-component";

export default class Radio extends AuxiliumComponent {
	static observable = ["name", "value", "label", "helper-text"];
	static observableBooleans = ["checked", "required"];

	#Mappers = {};

	constructor() {
		super();

		this.value ??= "true";

		this.#Mappers = {
			name: this.name
		};

		if (this.closest("form") && !this.#Mappers.name) { this.#Mappers.name = this.id ?? this.identifier; }
	}

	parsedCallback() {
		this.classList.add("checkbox__wrapper");

		const radio = document.createElementWithContents("input", null, {
			id: this.identifier,
			className: "input-field",
			type: "radio",
			checked: this.checked,
			value: this.value
		});

		radio.onchange = () => document.querySelectorAll(`chip-radio[name='${this.#Mappers.name}']`).forEach(x => x.checked = x === this);

		Object.keys(this.#Mappers).filter(x => this.#Mappers[x])
			.forEach(key => radio.setAttribute(key, this.#Mappers[key] === true ? "" : this.#Mappers[key]));

		if (this.helperText) {
			this.prepend(document.createElementWithContents("div", this.helperText, {
				className: "input-field__helper-text"
			}));
		}

		if (this.label) { this.prepend(document.createElementWithContents("label", this.label, { htmlFor: this.identifier })); }

		this.prepend(radio);
	}

	focus() {
		this.querySelector("input")?.focus();
	}

	attributeChanged(name, _, newValue) {
		if (name === "checked") {
			this.querySelector("input").checked = this.IsAttributeValueTrue(newValue);
		}
	}
}
